export const EMPLOYMENT_TYPES = [
  {
    value: "SALARIED",
    label: "Salaried",
  },
  {
    value: "SELF_EMPLOYED",
    label: "Self Employed",
  },
  // {
  //   value: "BUSINESS_OWNER",
  //   label: "Business Owner",
  // },
  {
    value: "PROFESSIONAL",
    label: "Professional",
  },
  // {
  //   value: "RETIRED",
  //   label: "Retired",
  // },
  // {
  //   value: "OTHER",
  //   label: "Other",
  // },
];

export const EMPLOYMENT_TYPE_LABELS = Object.fromEntries(
  EMPLOYMENT_TYPES.map((item) => [item.value, item.label]),
);

export const getEmploymentTypeLabel = (value) =>
  EMPLOYMENT_TYPE_LABELS[value] ?? value ?? "—";
